import { HTTP_INTERCEPTORS } from '@angular/common/http';
import type { Provider } from '@angular/core';
import { ErrorHandler } from '@angular/core';

import { MonitoringErrorHandler } from './monitoring.error-handler';
import { MonitoringInterceptor } from './monitoring.interceptor';

export function getMonitoringProviders(): Provider[] {
  return [
    {
      provide: ErrorHandler,
      useClass: MonitoringErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MonitoringInterceptor,
      multi: true,
    },
  ];
}
